import React from 'react';
import { motion } from 'framer-motion';

export const SEOContent = ({ title, content }) => {
  return (
    <section className="py-12 bg-[#eff0f0]">
      <div className="container mx-auto px-4 lg:px-8 max-w-4xl">
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          className="text-center"
        >
          {title && (
            <h2 className="text-xl font-medium text-[#0b382a]/70 mb-3">
              {title}
            </h2>
          )}
          <p className="text-[#0b382a]/60 leading-relaxed">
            {content}
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default SEOContent;
